module.exports = __webpack_public_path__ + "static/img/cqxcrw.668e5b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/cqxcrw.svg
// module id = 5UbQ
// module chunks = 0